module.exports = __webpack_public_path__ + "img/mu-img-login-bg.3a3bf118.jpg";